import React from 'react'
import { withRouter } from 'react-router-dom';
import {Box,Card,CardHeader, CardBody,Button,Heading, Text,CardFooter} from 'grommet';
import { Alert,Update } from 'grommet-icons';
import { NavigationSnackBar } from '../../components/utils/shared/shared';


function goBack(props){
    props.history.goBack()
}   

function CollectionFail(props) {
    const shipment = props.location.state.shipment
    console.log(shipment)
    return (
    <Box>
        <NavigationSnackBar title={'Collection Unsuccuessful'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Create Collection', link: '/collection/new'}]}  />
        <Box direction='column' justify="center" margin='small'>
            <Card pad="medium" gap="small" justify='start' align='start'>
                <CardHeader>
                <Alert color='status-critical'/>
                    <Heading level={4} size="small">Quote Unsuccessful</Heading>
                </CardHeader>
                <CardBody justify='start' direction='column'>
                    <Text>Error Code: {shipment.collection.Status.Code}</Text>
                    <Text>Error Message: {shipment.collection.Status.Message}</Text>
                </CardBody>
                <CardFooter>
                    <Button margin="small" icon={<Update color='status-ok'/>} label={"Try Again"} type='button' onClick={() =>goBack(props)}/>
                </CardFooter>
            </Card>
        </Box>
    </Box>
  )
}

export default withRouter(CollectionFail)
